<template>
  <UiBaseIcon
    width="6"
    height="8"
    viewBox="0 0 6 8"
    class="icon"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.4394 4.00006L0.969727 1.53039L2.03039 0.469727L5.56072 4.00006L2.03039 7.53039L0.969727 6.46973L3.4394 4.00006Z"
      fill="#202020"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
